import DefaultLayout from '~pages/layouts/DefaultLayout.vue'
import MmpHeader from '~pages/layouts/MmpHeader.vue'
import MmpFooter from '~pages/layouts/MmpFooter.vue'
import PromotionMain from '~pages/contents/promotion/PromotionMain.vue'
import PromotionDetail from '~pages/contents/promotion/PromotionDetail.vue'

import memberRoute from '~cfg/router/child/member'
import errorRoute from '~cfg/router/child/error'
import cartRoute from '~cfg/router/child/cart'
import mypageRoute from '~cfg/router/child/mypage'
import paymentRoute from '~cfg/router/child/payment'
import callBackRoute from '~cfg/router/child/callback'

import { isEmpty, toLower } from 'lodash'
// 과정//
import courseRoute from '~cfg/router/child/course'

// ::::: Nrw START
import NrwDefaultLayout from '~pages/nrw/layouts/NrwDefaultLayout.vue'
import NrwRouter from '~cfg/router/nrw/NrwRouter'

import NrwHeader from '~pages/nrw/layouts/NrwHeader.vue'
import NrwFooter from '~pages/nrw/layouts/NrwFooter.vue'
import NrwBottom from '~pages/nrw/layouts/NrwBottom.vue'
import NrwHome from '~pages/nrw/main/Home.vue'

import NrwErrRouter from '~cfg/router/nrw/child/errorRouter'
// ::::: Nrw END

import Vue from 'vue'

import apiKeys from '@/config/code/apiKeys'

var defaultRoutesPromo = [
  {
    path: '/',
    meta: {
      isAbstract: true
    },
    component: DefaultLayout,
    beforeEnter: (to, from, next) => {
      next()
    },
    children: [
      {
        path: '',
        name: 'index',
        beforeEnter: (to, from, next) => {
          console.log(to, from)
          next()
        },
        components: {
          header: MmpHeader,
          content: PromotionMain,
          footer: MmpFooter
        },
        meta: {
          authorized: false,
          wrapClass: 'promotion'
        }
      },
      {
        path: '/promoDetail/:subHtml',
        name: 'PromoDetail',
        beforeEnter: (to, from, next) => {
          if (isEmpty(to.params.subHtml)) {
            next({name: 'index'})
          } else {
            next()
          }
        },
        components: {
          header: MmpHeader,
          content: PromotionDetail,
          footer: MmpFooter
        },
        meta: {
          authorized: false,
          wrapClass: 'promotion_sub'
        }
      }
    ].concat(memberRoute, cartRoute, mypageRoute, paymentRoute, callBackRoute, courseRoute)
  },
  {
    path: '*',
    redirect: {
      name: '404'
    }
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      isAbstract: true
    },
    component: DefaultLayout,
    children: [].concat(errorRoute)
  }
]

var defaultRoutesNrw = [
  {
    path: '/',
    meta: {
      isAbstract: true
    },
    component: NrwDefaultLayout,
    beforeEnter: (to, from, next) => {
      next()
    },
    children: [
      {
        path: '',
        name: 'index',
        beforeEnter: (to, from, next) => {
          console.log(to, from)
          next()
        },
        components: {
          header: NrwHeader,
          content: NrwHome,
          footer: NrwFooter,
          bottom: NrwBottom
        },
        meta: {
          authorized: false,
          wrapClass: 'promotion'
        }
      }
    ].concat(NrwRouter)
  },
  {
    path: '*',
    redirect: {
      name: '404'
    }
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      isAbstract: true
    },
    component: NrwDefaultLayout,
    children: [].concat(NrwErrRouter)
  }
]

var defaultRoutes = []

export default {

  checkAuthorizeRouter: async function (to, from, next) {
    // console.log('checkAuthorizeRouter', to, from, next)

    let mmpAuthStore = window.vue.getStore('mmpAuth')
    let tokenStore = window.vue.getStore('token')
    let rootStore = window.vue.getStore('root')

    // if (mmpAuthStore.getters.isAutoLogin && (isEmpty(tokenStore.getters.getTokenAuth) || isEmpty(rootStore.getters.getSession)) ) {
    //   rootStore.commit('LOG_IN', mmpAuthStore.state.session)
    //   tokenStore.commit('REGISTER', mmpAuthStore.state.token)
    // }

    if (rootStore.getters.getSession.userId !== undefined) {
      window._id = rootStore.getters.getSession.userId
    } else {
      window._id = ''
    }
    if (rootStore.getters.getSession.mbrSxdsCd !== undefined) {
      window._gender = rootStore.getters.getSession.mbrSxdsCd
    } else {
      window._gender = ''
    }

    // from.query에서 UTM 파라미터 추출, to.query에 UTM 파라미터가 없는 경우만 추가
    const newQuery = { ...to.query }
    let hasNewData = false
    Object.keys(from.query).forEach(key => {
      if (key.startsWith('utm_') && !newQuery.hasOwnProperty(key)) {
        newQuery[key] = from.query[key]
        hasNewData = true
      }
    })

    /*
    { // 뒤로가기시 검색등 레이어가 뜬 경우.. 필요하면 주석 해제 후, 테스트 요망
      let isMobile = !window.vue.getStore('homeInfo').state.isDeskTopMode
      let continueFlag = true
      // 모바일의 경우, 뒤로가기시 레이어 팝업 닫기로,, 카테고리 및 통합검색 레이어
      if (Vue.prototype.$nrwHeader) {
        let nrwHeader = Vue.prototype.$nrwHeader
        let nrwTotalSearch = Vue.prototype.$nrwTotalSearchMain
        try {
          const categoryDiv = document.querySelector('.wrap_category_menu_expand')
          // wrap_category_menu_expand
          let isShowCategoryMenu = isMobile && categoryDiv && categoryDiv.classList && categoryDiv.classList.contains('active')
          console.log('checkAuthorizeRouter::hrwHeader.isShowCategoryMenu', isShowCategoryMenu)

          const searchDiv = document.querySelector('.wrap_search_ui')
          let isShowSearchDiv = isMobile && searchDiv && searchDiv.classList && searchDiv.classList.contains('active')
          console.log('checkAuthorizeRouter::hrwHeader.isShowSearchDiv', nrwTotalSearch, isShowSearchDiv)

          // 뒤로가기 대신 카테고리 레이어 닫기
          if (isShowCategoryMenu) {
            nrwHeader.hideCategoryMenu()
            console.log('checkAuthorizeRouter::hrwHeader.beforeCategoryMoveFlag', nrwHeader.beforeCategoryMoveFlag)
            if (nrwHeader.beforeCategoryMoveFlag) { // 카테고리 직접 클릭했을 경우에만 이동 시킴
              // next(true)
            } else {
              // 이동 막기
              next(false)
              continueFlag = false
            }
          }

          // 뒤로가기 대신 통함검색 레이어 닫기
          if (continueFlag && nrwTotalSearch && isShowSearchDiv) {
            nrwTotalSearch.close()
            if (nrwTotalSearch.beforeSearchMoveFlag) {
              // next(true)
            } else {
              // 이동 막기
              next(false)
              continueFlag = false
            }
          }

          const gnbAlarmDiv = document.querySelector('.gnb__alarm')
          let isGnbAlarmActive = gnbAlarmDiv && gnbAlarmDiv.classList && gnbAlarmDiv.classList.contains('active') // isMobile 제거,  알림은 .
          console.log('checkAuthorizeRouter::hrwHeader.isGnbAlarmActive', gnbAlarmDiv, isGnbAlarmActive)

          // 뒤로가기 대신 알람 목록 레이어 닫기
          if (continueFlag && !isGnbAlarmActive) {
            // next(true)
          } else {
            nrwHeader.closeGnbLayer('gnb__alarm')
            document.body.classList.remove('fixed_body')
            // gnbAlarmDiv.classList.remove('active') // active 헤제
            // 이동 막기
            next(false)
            continueFlag = false
          }
        } finally {
          if (nrwHeader) nrwHeader.beforeCategoryMoveFlag = false
          if (nrwTotalSearch)nrwTotalSearch.beforeSearchMoveFlag = false
        }
      }
      if (!continueFlag) return
    }
    */

    if (to.meta && to.meta.authorized) {
      let httpObj = window.vue.getInstance('http')
      httpObj.busn = httpObj.busn ? httpObj.busn : httpObj.b2c
      let isLogin = window.vue.getStore('root').state.session.authenticated
      console.log('>>isLogin', isLogin, tokenStore.getters.getTokenAuth)
      if (rootStore !== null && rootStore.getters.getSession.authenticated && tokenStore.getters.getTokenAuth) {
        let eduGrpCd = window.vue.getStore('promoInfo').getters.getPromoInfo.eduGroupCode
        let coGroupCode = window.vue.getStore('promoInfo').getters.getPromoInfo.coGroupCode
        console.log('>>memberTokenValidation', hasNewData, newQuery )
        console.log('>>checkAuthorizeRouter eduGrpCd / coGroupCode', eduGrpCd, coGroupCode)
        console.log('>>memberTokenValidation', tokenStore.getters.getTokenAuth )

        // promoStore.state.promoInfo
        await httpObj.busn.memberTokenValidation(undefined, { mbrToken: tokenStore.getters.getTokenAuth, eduGrpCd: eduGrpCd }).then( (tokenValidationRes) => {
          const data = tokenValidationRes.data
          if (to.name === 'Login' || to.path === '/member/login') {
            let beforeRouteObj = mmpAuthStore.state.beforeRoute
            if (isEmpty(beforeRouteObj)) {
              beforeRouteObj = {name: 'index'}
            }
            if (hasNewData) { // utm 유실 수정
              beforeRouteObj.query = newQuery // utm 유실 수정
            }
            // console.log('>>> checkAuthorizeRouter 1111')
            next(beforeRouteObj)
          } else {
            console.log('$$$$$$$$$ data.status', data.status)
            if (data.status === 'ERROR') {
              window.vue.getStore('root').commit('LOG_OUT')
              window.vue.getStore('token').commit('DELETE')
              window.vue.getStore('mmpAuth').commit('CLEAR_AUTO_LOGIN')

              console.log('>>> 로그아웃되었습니다. 메인페이지로 이동합니다')
              Vue.popup.alert(window.vue.$el, {title: '로그아웃', contents: '로그아웃되었습니다. 메인페이지로 이동합니다.'}).then((result) => {
                window.vue.getInstance('router').push({name: 'index'})
              })
            } else {
              // mmpAuthStore.commit('SET_BEFORE_ROUTE', {})
              if (hasNewData) { // utm 유실 수정
                next({ ...to, query: newQuery })
              } else {
                next()
              }
            }
          }
        }).catch( error => {
          console.log('>>> checkAuthorizeRouter error')
          console.log(error)
          next({ name: 'Login', query: newQuery })
        })
      } else {
        console.info('unauthorized to access')
        var alertTitle = to.meta.title || '알림'
        var authConfirm = await Vue.popup.confirm(undefined, {title: alertTitle, contents: '로그인이 필요한 메뉴입니다. <br> 로그인하시겠습니까?', okBtnNm: '로그인'})

        if (authConfirm) {
          console.log('>>로그인전', to, from)
          if (to.name !== 'Login' && to.path !== '/member/login') {
            mmpAuthStore.commit('SET_BEFORE_ROUTE', to)
          }

          next({ name: 'Login', query: newQuery })
        } else {
          // console.log('checkAuthorizeRouter', to, from, next)
          if (_.isEmpty(from.name)) {
            // location.href = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))
            history.back()
          }
        }
      }
    } else {
      if (rootStore !== null && rootStore.getters.getSession.authenticated &&
        tokenStore.getters.getTokenAuth && (to.name === 'Login' || to.path === '/member/login')) {
        let beforeRouteObj = mmpAuthStore.state.beforeRoute
        if (isEmpty(beforeRouteObj)) {
          beforeRouteObj = {name: 'index'}
        }

        if (hasNewData) { // utm 유실 수정
          beforeRouteObj.query = newQuery // utm 유실 수정
        }
        next(beforeRouteObj)
      } else {
        // TOTALSR-71929
        if (to.name === 'Login' || to.path === '/member/login') {
          let beforeRouteObj = window.vue.getStore('mmpAuth').state.beforeRoute
          // 로그인전에 나의공간 아이콘을 클릭 했을 경우와 1:1문의 클릭시에는 메인으로 가지 않고 해당 메뉴로 이동시킴(MmpBeforeRouteCheck:78라인과 같이)
          console.log('check SET_BEFORE_ROUTE', from)
          if (beforeRouteObj.name !== 'MyDashbrd' && beforeRouteObj.name !== 'Inquiry' ) mmpAuthStore.commit('SET_BEFORE_ROUTE', from)
        }
        if (hasNewData) { // utm 유실 수정
          next({ ...to, query: newQuery })
        } else {
          next()
        }
      }
    }
  },
  getRootRoutes: function (mmpInfoResData) {
    if (mmpInfoResData.data !== undefined && !isEmpty(mmpInfoResData.data)) {
      let contextRoot = '/' + (isEmpty(mmpInfoResData.data.contextPath) ? '' : mmpInfoResData.data.contextPath)
      defaultRoutes[0].path = contextRoot
    } else {
      defaultRoutes[0].children = []
      defaultRoutes[0].redirect = {
        name: '404'
      }
    }

    return defaultRoutes
  },
  getErrorRoutes: function () {
    defaultRoutes[0].children = []
    defaultRoutes[0].redirect = {
      name: '404'
    }

    return defaultRoutes
  },
  getApikey () {
    let defaultObj = {
      host: '',
      kakao_key: '',
      google_key: '',
      facebook_key: '',
      naver_key: ''
    }
    return apiKeys.LOGIN_API_KEY.find((item) => window.location.host.indexOf(item.host) > -1 ) || defaultObj
  },
  generateRouter (Router) {
    let isNrwMobile = false
    Vue.utils.user.checkLoginSession()
    // m.multi ... 시작 도메인일 경우, 웹 모바일로 분기
    if (window.location.hostname.startsWith('m.') || window.location.hostname.startsWith('mstg.')) { // NRW : m.multi...
      isNrwMobile = true
      let mmpAuthStore = window.vue.getStore('mmpAuth')
      mmpAuthStore.commit('SET_NRW_INFO', isNrwMobile)
      console.log('>>isNrwMobile', mmpAuthStore.state.isNrwMobile)
    }
    if (isNrwMobile) {
      return new Promise( (resolve, reject) => {
        let apiKey = this.getApikey()
        console.log('apiKey', apiKey)
        let promoStore = window.vue.getStore('promoInfo')
        let homeInfoStore = window.vue.getStore('homeInfo')
        let httpObj = window.vue.getInstance('http')
        httpObj.busn = httpObj['b2c']
        defaultRoutes = defaultRoutesNrw

        let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, false)

        let eduGrpCd = promoStore.getters.getPromoInfo.eduGroupCode
        let coGroupCode = promoStore.getters.getPromoInfo.coGroupCode
        console.log('>>generateRouter eduGrpCd / coGroupCode', eduGrpCd, coGroupCode)

        httpObj.busn.selectMobileInfo(undefined, {eduGrpCd: 'CUS0001'}).then( (result) => {
          console.log('selectMobileInfo', result.data)
          if (result.data.code === 'OK') {
            let mobInfo = result.data.data.mobInfo
            console.log('selectMobileInfo', mobInfo)
            homeInfoStore.commit('SET_MOBILE_INFO', mobInfo)
            promoStore.commit('SET_PROMO_INFO', {
              eduGroupCode: mobInfo.eduGrpCd, // result.data.data.eduGrpCd, // CUS0001
              coGroupCode: 'B2C_18_001', // result.data.data.coGrpCd, // B2C_18_001
              activeYn: 'Y',
              busnCd: 'B2C',
              contextPath: '/',
              dmnScCd: 'B',
              evtExpl: '',
              facbkCtfcKeyCntnt: apiKey.facebook_key, // '2336583159899761', // fbApiKey
              googlCtfcKeyCntnt: apiKey.google_key, // '129407983752-sqokckpifvcc0cpfd8vg5u96ctc0t0oh.apps.googleusercontent.com', // googlApiKey
              kakaoCtfcKeyCntnt: apiKey.kakao_key, // 'b84f9a7e25a2bd8785c17de6d7adb62e', // kakaoApiKey
              naverCtfcKeyCntnt: apiKey.naver_key, // 'mUy5GYjMbGHNb4LA6iJP', // naverApiKey
              promoId: 'Next', // '26771251-c435-459f-bcbc-60a1f9cc08c9',
              promoNm: mobInfo.intrSiteNm, // 'Multicampus', // result.data.data.siteTitlNm,
              rownum: 1,
              snsLoginMrkYn: 'Y',
              virtualPath: '/'
            })
            console.log('promoStore.state.promoInfo::isNrwMobile', promoStore.state.promoInfo)
          }
          window.vue.setInstance('router', router)
          resolve()
        }).catch( error => {
          console.log(error)
          defaultRoutes[0].children = []
          defaultRoutes[0].redirect = {
            name: '404'
          }

          window.vue.setInstance('router', router)
          resolve()
        })
      })
    } else {
      console.log('##########defaultRoutesPromo', defaultRoutesPromo)
      defaultRoutes = defaultRoutesPromo

      return new Promise( (resolve, reject) => {
        let httpObj = window.vue.getInstance('http')
        let promoStore = window.vue.getStore('promoInfo')
        let dmnNm = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port)) + window.location.pathname

        if (dmnNm.indexOf('http://localhost/ppt1') >= 0) {
          dmnNm = dmnNm.replace('http://localhost/ppt1', 'http://event.multicampus.com/ppt1')
        }

        console.log('##########dmnNm', dmnNm, window.location.pathname)
        console.log('##########process.env.NODE_ENV ', process.env.NODE_ENV)
        if (process.env.NODE_ENV === 'local' || dmnNm.indexOf('local.host') > -1) {
          dmnNm = 'https://event.multi-qa.com/main'
        }

        console.log('##########dmnNm', dmnNm)
        // TODO :  로컬 테스트용 .. 품질 반영시 삭제할것
        // console.log('>>> dmnNm', dmnNm)
        // if (dmnNm.indexOf('local') >= 0) {
        //   dmnNm = 'http://event.multicampus.com/main'
        // }

        httpObj.mmp.mainPromo(undefined, {dmnNm: dmnNm}).then( (result) => {
          let basePath = ''

          if (result && result.data !== undefined &&
            result.data.data !== undefined && !isEmpty(result.data.data)) {
            basePath = isEmpty(result.data.data.contextPath) ? '' : ('/' + result.data.data.contextPath)

            let linkUrl = result.data.data.linkUrl
            if (linkUrl) {
              const queryParams = window.location.search

              // 새 URL 객체 생성
              const redirectUrl = new URL(linkUrl)

              // 새 URL에 기존 파라미터 추가
              if (redirectUrl.search.length === 0) {
                // URL이 쿼리 파라미터를 가지고 있지 않은 경우
                redirectUrl.search = queryParams
              } else {
                // 이미 쿼리 파라미터가 있는 경우
                redirectUrl.search += '&' + queryParams.slice(1)
              }
              window.location.href = redirectUrl.href
              return
            }
          }

          promoStore.commit('SET_PROMO_INFO', result.data.data)
          httpObj.busn = httpObj[toLower(result.data.data.busnCd)]
          httpObj.busn = httpObj.busn ? httpObj.busn : httpObj.b2c
          console.log('promoStore.state.promoInfo::MMP', promoStore.state.promoInfo)
          let router = Router.createInstance(defaultRoutes, basePath, this.checkAuthorizeRouter, true)
          window.vue.setInstance('router', router)
          resolve()
        }).catch( error => {
          console.log(error)
          defaultRoutes[0].children = []
          defaultRoutes[0].redirect = {
            name: '404'
          }
          httpObj.busn = httpObj.busn ? httpObj.busn : httpObj.b2c
          console.log('$$$$$$$$ promoStore Error', promoStore)
          let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
          window.vue.setInstance('router', router)
          resolve()
        })
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/config/router/rootRoutes.js